/**
 * ModalSize
 * Preset widths for use with the size property of the ModalView component.
 * DYNAMIC is the default
 */
export enum MODAL_SIZE {
  DYNAMIC = 'auto',
  X_SMALL = '300px',
  SMALL   = '600px',
  MEDIUM  = '800px',
  LARGE   = '1000px',
}
